// NATIVE
import { FC } from 'react';

// INSTALLED
import * as Icons  from "@mui/icons-material";
import { SvgIconProps } from '@mui/material';

// CUSTOM


type CustomIconProps = {
  iconName: any
} & SvgIconProps



export const IconByString: FC<CustomIconProps> = ({
    iconName,
    ...props
  }) => {
    const Icon = (Icons as any)[iconName]
    
    if (!Icon) {
        // Fallback to a default icon or null to prevent crash
        return <Icons.HelpOutline {...props} />; 
    }

    return <Icon {...props} />
  }